

























































































import Vue from 'vue';
import {
  OpenUpdateProviderScreen,
  OpenRemoveProviderScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import { MemberProvidersResponseModel } from '@/@types/member';
import DataTableSync from 'datatablesync/src/DataTableSync.class';
import { createDataTableSyncInstance } from '@/factories';
import { TableDefaults } from '@/constants';
import { EventBus } from '@/event-bus';

interface Data {
  rowsPerPageItems: number[];
  selectedProviderIndex: number;
}

export default ExtendMixins(
  OpenUpdateProviderScreen,
  OpenRemoveProviderScreen,
).extend({
  name: 'ProviderListing',
  beforeMount(): void {
    // INITIALIZE DATA TABLE SYNC
    createDataTableSyncInstance({
      vuexAction: {
        actionName: 'getProviders',
      },
      refs: this.$refs,
      refName: this.dataTableRef,
      dispatchOnLoad: true,
      persistTableState: true,
      paginationConfig: Object.assign(
        {},
        TableDefaults.createTableOnlyPagination(),
        { rowsPerPage: 25 },
      ),
    });
    this.dataTableSync.totalItems =
      this.dataTableSync.totalItems || Number(this.$store.getters.totalItems);
    EventBus.$on('updatedProvider', (response) => {
      this.selectUpdatedProviderPanel(response.providerId);
    });
  },
  props: {
    dataTableRef: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      rowsPerPageItems: [25],
      selectedProviderIndex: null,
    };
  },
  computed: {
    dataTableSync(): DataTableSync {
      return this.$store.getters.currentDataTableSyncInstance(
        this.dataTableRef,
      );
    },
    providers(): MemberProvidersResponseModel[] {
      return this.$store.getters.providers.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
    },
  },
  methods: {
    selectUpdatedProviderPanel(providerId): void {
      const providerIndex = this.providers.findIndex((provider) => {
        return provider.providerId === providerId;
      });
      this.selectedProviderIndex = providerIndex;
    },
    selectProvider(providerIndex): void {
      if (this.selectedProviderIndex === providerIndex) {
        this.selectedProviderIndex = null;
      } else {
        this.selectedProviderIndex = providerIndex;
      }
    },
  },
  watch: {
    'dataTableSync.pagination'() {
      document.getElementById('providersPageIntro').scrollIntoView();
      this.selectedProviderIndex = null;
    },
  },
});
